import type { CatalogueType } from '@/config/types'
import type { GA4AnalyticsEvent } from '@/domain/shared/types'

export interface QuickSearchFilterClickEventProps {
  element: 'checkbox' | 'dropdown' | 'calendar' | 'participants selector'
  type: string
  result: string | number | readonly string[] | undefined
}
export function createQuickSearchFilterClickEvent({
  element,
  type,
  result,
}: QuickSearchFilterClickEventProps): GA4AnalyticsEvent {
  return {
    event: 'clickQuickSearch',
    description: 'set quick search filter',
    element,
    type,
    result,
    interaction: true,
  }
}

export const QuickSearchCTAClickEvent: GA4AnalyticsEvent = {
  event: 'quickSearch',
  element: 'button',
  type: 'search',
  result: 'search',
  interaction: true,
}

export function createQuickSearchToggleClickEvent(selectedCatalogue?: CatalogueType): GA4AnalyticsEvent {
  const catalogue = selectedCatalogue ? selectedCatalogue === 'summer' ? 'sun' : 'ski' : 'extra'
  return {
    event: 'quickSearch',
    element: 'toggle',
    type: 'publication',
    result: catalogue,
    interaction: true,
  }
}
